import { supabase } from "@/integrations/supabase/client";

export async function getExchangeRate(from: string, to: string = 'USD', date?: string) {
  try {
    console.log('Fetching API key from Supabase...');
    const { data, error: secretError } = await supabase
      .functions.invoke('get-secret', {
        body: { name: 'EXCHANGE_RATE_API_KEY' }
      });

    if (secretError || !data?.EXCHANGE_RATE_API_KEY) {
      console.error('Failed to get API key:', secretError);
      throw new Error('Failed to get exchange rate API key');
    }

    const apiKey = data.EXCHANGE_RATE_API_KEY;
    console.log('Successfully got API key, fetching exchange rate...');

    const response = await fetch(
      `https://v6.exchangerate-api.com/v6/${apiKey}/latest/${from}`
    );
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Exchange rate API error:', errorText);
      throw new Error(`Exchange rate API error: ${response.status}`);
    }

    const rateData = await response.json();
    console.log('Exchange rate response:', rateData);
    
    if (!rateData.conversion_rates || !rateData.conversion_rates[to]) {
      console.error('No conversion rate found for', to);
      throw new Error(`No conversion rate found for ${to}`);
    }

    const rate = rateData.conversion_rates[to];
    console.log(`Exchange rate from ${from} to ${to}: ${rate}`);
    return rate;
  } catch (error) {
    console.error('Error in getExchangeRate:', error);
    // Return 1 as fallback rate to prevent app from breaking
    return 1;
  }
}